export class SearchCoursCriteria {
    designation: string;
    datedebut: Date;
    datefin: Date;
}


// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/searchcourscriteria.model.ts